<template>
  <div id="app">
    <div class="wrap" :class="{positions: helperHeightYn}">
      <HelperHeight :helperHeightYn="helperHeightYn" />
      <div class="intro">
        <div class="top-area">
          <div class="logo">
            <!-- <span class="ft--3xlg b-logo" v-if="brandLogo == null || brandLogo.DISP_KIND_CD == 'T'">Brand logo</span>-->
            <img v-if="brandLogo != null && brandLogo.DISP_KIND_CD == 'I'" :src="brandLogo.FILE_URL" alt="" class="b-logo" />
          </div>
          <div v-if="rollingScreen != null && rollingScreen.length == 1" class="slide-wrap one-item">
            <!-- 1개 일때 -->
            <div class="slide-item slide" v-for="screen in rollingScreen" :key="screen">
              <div class="img-area">
                <img :src="screen.FILE_URL" alt="" />
              </div>
              <div class="txt-area">
                <i class="ico-new"></i>
                <span class="txt">{{ screen.DISP_TEXT }}</span>
              </div>
            </div>
          </div>
          <div v-else-if="rollingScreen != null && rollingScreen.length >= 2">
            <div ref="mySwiper">
              <div class="slide-wrap swiper-wrapper">
                <!-- 슬라이드 하나 -->
                <div class="swiper-slide slide-item slide" v-for="screen in rollingScreen" :key="screen">
                  <div class="img-area">
                    <img :src="screen.FILE_URL" alt="" />
                  </div>
                  <div class="txt-area">
                    <i class="ico-new"></i>
                    <span class="txt">{{ screen.DISP_TEXT }}</span>
                  </div>
                </div>
                <div class="swiper-slide slide-item slide" v-for="screen in rollingScreen" :key="screen">
                  <div class="img-area">
                    <img :src="screen.FILE_URL" alt="" />
                  </div>
                  <div class="txt-area">
                    <i class="ico-new"></i>
                    <span class="txt">{{ screen.DISP_TEXT }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-wrapper">
          <div class="bottom-gradient"></div>
          <div class="bottom-area">
            <div class="left-area">
              <div class="intro__lang--col">
                <div class="txt-info">
                  <i class="ico-lang"></i>
                  <span>{{ $t('User.Idle.msg5') }}</span>
                </div>
                <div class="intro__slctlang">
                  <div
                    class="lang-item"
                    :class="{on: defaultLanguage == 'CH' ? $i18n.locale == 'cn' : $i18n.locale == defaultLanguage.toLowerCase()}"
                    @mouseup="
                      [(locales = defaultLanguage == 'CH' ? 'cn' : defaultLanguage.toLowerCase()), ($i18n.locale = locales)];
                      $logInfo(`Locale Change : ${defaultLanguage}`);
                    "
                  >
                    <span v-if="defaultLanguage == 'JP'">{{ $t('User.Idle.msg6') }}</span>
                    <span v-if="defaultLanguage == 'KO'">{{ $t('User.Idle.msg7') }}</span>
                    <span v-if="defaultLanguage == 'EN'">{{ $t('User.Idle.msg8') }}</span>
                    <span v-if="defaultLanguage == 'CH'">{{ $t('User.Idle.msg9') }}</span>
                    <span v-if="defaultLanguage == 'TW'">{{ $t('User.Idle.msg10') }}</span>
                  </div>

                  <div
                    v-for="locale in supportLocale.filter((loc) => loc != defaultLanguage)"
                    :key="locale"
                    class="lang-item"
                    :class="{on: locale == 'CH' ? $i18n.locale == 'cn' : $i18n.locale == locale.toLowerCase()}"
                    @mouseup="
                      [(locales = locale == 'CH' ? 'cn' : locale.toLowerCase()), ($i18n.locale = locales)];
                      $logInfo(`Locale Change : ${locale}`);
                    "
                  >
                    <span v-if="locale == 'JP'">{{ $t('User.Idle.msg6') }}</span>
                    <span v-if="locale == 'KO'">{{ $t('User.Idle.msg7') }}</span>
                    <span v-if="locale == 'EN'">{{ $t('User.Idle.msg8') }}</span>
                    <span v-if="locale == 'CH'">{{ $t('User.Idle.msg9') }}</span>
                    <span v-if="locale == 'TW'">{{ $t('User.Idle.msg10') }}</span>
                  </div>
                </div>
                <button v-if="idleScreenExtrasType.split('')[0] == 1" class="btn--line-b btn-anim" @mouseup="$emit('emReady')">
                  <i class="ico-emoney ico-sm"></i><span>{{ $t('User.Idle.msg11') }}</span>
                </button>
                <button v-if="idleScreenExtrasType.split('')[2] == 1" class="btn--line-b btn-anim" @mouseup="$emit('staffCall')">
                  <i class="ico-staff ico-sm"></i><span>{{ $t('User.Idle.msg12') }}</span>
                </button>
                <button v-if="idleScreenExtrasType.split('')[1] == 1" class="btn--line-b btn-anim" @mouseup="$emit('helper')">
                  <i class="ico-helper ico-sm"></i><span>{{ $t('User.Idle.msg13') }}</span>
                </button>
              </div>
            </div>

            <div class="right-area">
              <div class="ft--3xlg-lh16" v-if="dispText != null">
                <!-- {{ $t('User.Idle.msg1') }} -->
                {{ dispText.replaceAll('^', '\n') }}
              </div>
              <div class="btn-area">
                <!-- type01 추가 -->
                <div class="intro__btns type01">
                  <!-- 버튼 텍스트 색상 흰색 스타일 추가 btn-intro--w -->
                  <button
                    v-if="(idleScreenOrderType == '01' || idleScreenOrderType == '03') && this.$store.getters.getSettingType != '3'"
                    :class="false ? 'btn-intro--md' : 'btn-intro--lg'"
                    class="btn-intro--w btn--color btn--shadow btn-anim"
                    @mouseup="
                      $router.push('/user/order');
                      $store.dispatch('setOrderType', 1);
                      $logInfo('Order Click Eat In');
                    "
                  >
                    <span class="txt">{{ $t('User.Idle.msg2') }}</span>
                    <IconGo class="ico-go" />
                  </button>
                  <button
                    v-if="(idleScreenOrderType == '02' || idleScreenOrderType == '03') && this.$store.getters.getSettingType != '3'"
                    :class="false ? 'btn-intro--md' : 'btn-intro--lg'"
                    class="btn-intro--w btn--black btn--shadow btn-anim"
                    @mouseup="
                      $router.push('/user/order');
                      $store.dispatch('setOrderType', 2);
                      $logInfo('Order Click Takeout');
                    "
                  >
                    <span class="txt">{{ $t('User.Idle.msg3') }}</span>
                    <IconGo class="ico-go" />
                  </button>
                  <button
                    v-if="idleScreenOrderType == '00' && this.$store.getters.getSettingType != '3'"
                    class="btn-intro--w btn--black btn--shadow btn-anim btn-intro--lg"
                    @mouseup="
                      $router.push('/user/order');
                      $store.dispatch('setOrderType', 3);
                      $logInfo('Order Click Start');
                    "
                  >
                    <span class="txt">시작하기</span>
                    <IconGo class="ico-go" />
                  </button>

                  <button
                    v-if="this.$store.getters.getSettingType == '3'"
                    :class="false ? 'btn-intro--md' : 'btn-intro--lg'"
                    class="btn-intro--w btn--black btn--shadow btn-anim"
                    @mouseup="
                      $router.push('/user/order');
                      $store.dispatch('setOrderType', 1);
                    "
                  >
                    <span class="txt">{{ $t('User.Idle.msg14') }}</span>
                    <IconGo class="ico-go" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helperHeight from '@/components/common/HelperHeight.vue';

// Import Swiper and modules
import Swiper, {Autoplay} from 'swiper';
import audioHelper from '@/js/common/audioHelper.js';

import IconGo from '@/components/common/IconGo.vue';

// Import Swiper styles
// import 'swiper/css';
// import 'swiper/css/autoplay';

export default {
  name: 'idle1',
  methods: {
    changeLocale() {
      // let currUnit = this.$store.getters.getCurrencyUnit;
      if (this.rollingScreen == null) return null;

      if (this.$i18n.locale == 'jp') {
        this.rollingScreen.forEach((item) => {
          item.DISP_TEXT = item.DISP_TEXT_JP;
        });
        // let currText = currUnit == '001' ? ' won' : currUnit == '003' ? ' 円' : '';
        // this.$store.dispatch('setCurrencyUnitText', currText);
      } else if (this.$i18n.locale == 'ko') {
        this.rollingScreen.forEach((item) => {
          item.DISP_TEXT = item.DISP_TEXT_KO;
        });
        // let currText = currUnit == '001' ? ' 원' : currUnit == '003' ? ' yen' : '';
        // this.$store.dispatch('setCurrencyUnitText', currText);
      } else if (this.$i18n.locale == 'en') {
        this.rollingScreen.forEach((item) => {
          item.DISP_TEXT = item.DISP_TEXT_EN;
        });
        // let currText = currUnit == '001' ? ' won' : currUnit == '003' ? ' yen' : '';
        // this.$store.dispatch('setCurrencyUnitText', currText);
      } else if (this.$i18n.locale == 'cn') {
        this.rollingScreen.forEach((item) => {
          item.DISP_TEXT = item.DISP_TEXT_CN;
        });
        // let currText = currUnit == '001' ? ' won' : currUnit == '003' ? ' yen' : '';
        // this.$store.dispatch('setCurrencyUnitText', currText);
      } else if (this.$i18n.locale == 'tw') {
        this.rollingScreen.forEach((item) => {
          item.DISP_TEXT = item.DISP_TEXT_TW;
        });
        // let currText = currUnit == '001' ? ' won' : currUnit == '003' ? ' yen' : '';
        // this.$store.dispatch('setCurrencyUnitText', currText);
      }
      this.$store.dispatch('setLocale', this.$i18n.locale);
    },
  },
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      locales: this.$i18n.locale,
      dispTextArr:
        this.$store.getters.getMasterData.TB_MST_CUST_DISP == null
          ? null
          : this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.DISP_AREA == '04'),
      supportLocale: this.$store.getters.getPosConfig.posConfig.supportLanguages,
      defaultLanguage: this.$store.getters.getPosConfig.posConfig.defaultLanguage,
      voiceSupportYn: this.$store.getters.getPosConfig.posConfig.useVoiceSupport,
      //대기화면 부가 기능 버튼
      idleScreenExtrasType: parseInt(this.$store.getters.getPosConfig.posConfig.idleScreenExtrasType).toString(2).padStart(3, '0'),
      //주문 방법 선택 여부
      idleScreenOrderType: this.$store.getters.getPosConfig.posConfig.idleScreenOrderType,
    };
  },
  created() {},
  mounted() {
    this.changeLocale();
    let that = this;
    if (this.rollingScreen != null && this.rollingScreen.length >= 2) {
      const swiperObj = new Swiper(that.$refs.mySwiper, {
        // configure Swiper to use modules
        modules: [Autoplay],
        // Optional parameters
        direction: 'vertical',
        height: 1064,
        spaceBetween: 125,
        loop: true,
        loopedSlides: 2,
        slidesPerView: 1,
        speed: 5000,
        allowTouchMove: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
      });
    }

    try {
      //this.audio.play(); // 20230406 HSSHIN Audio 재생
      let locale;
      let posConfig = this.$store.getters.getPosConfig;
      if (posConfig.posConfig.defaultLanguage == 'KO') locale = 'ko';
      else if (posConfig.posConfig.defaultLanguage == 'JP') locale = 'jp';
      else if (posConfig.posConfig.defaultLanguage == 'EN') locale = 'en';
      else if (posConfig.posConfig.defaultLanguage == 'CH') locale = 'cn';
      else if (posConfig.posConfig.defaultLanguage == 'TW') locale = 'tw';

      audioHelper.playAudio('00100', locale, posConfig.posConfig.useVoiceSupport);
    } catch (ex) {
      console.error(ex);
    }

    this.$showButtonAnimation();

    this.$log.info('IDLE', 'Enter IDLE 1 page');
  },
  unmounted() {
    try {
      //this.audio.pause(); // 20230406 HSSHIN Audio 중지
      audioHelper.stopAudio();
    } catch (ex) {
      console.error(ex);
    }
  },
  components: {
    HelperHeight: helperHeight,
    IconGo: IconGo,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    helperHeightYn() {
      return this.$store.getters.getHelperHeightYn;
    },
    dispText() {
      if (this.dispTextArr == null) return null;
      const date = new Date();
      //let now = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      // 메인 로고 텍스트
      let textArr = this.dispTextArr.filter(
        (item) => this.$strToDate(item.FROM_TIME, item.END_TIME, 0) <= date < this.$strToDate(item.FROM_TIME, item.END_TIME, 1)
      );
      if (textArr && textArr.length > 0) {
        if (this.$i18n.locale == 'jp') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_JP;
          });
        } else if (this.$i18n.locale == 'ko') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_KO;
          });
        } else if (this.$i18n.locale == 'en') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_EN;
          });
        } else if (this.$i18n.locale == 'cn') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_CN;
          });
        } else if (this.$i18n.locale == 'tw') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_TW;
          });
        }

        return textArr[0].DISP_TEXT;
      } else {
        return '';
      }
    },
    rollingScreen() {
      if (this.$store.getters.getMasterData.TB_MST_CUST_DISP == null) return null;
      const date = new Date();
      //let now = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      return this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.DISP_AREA == '06').filter(
        (item) => this.$strToDate(item.FROM_TIME, item.END_TIME, 0) <= date < this.$strToDate(item.FROM_TIME, item.END_TIME, 1)
      );
    },
    brandLogo() {
      if (this.$store.getters.getMasterData.TB_MST_CUST_DISP == null) return null;
      const date = new Date();
      //let now = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());

      return this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.DISP_AREA == '02').filter(
        (item) => this.$strToDate(item.FROM_TIME, item.END_TIME, 0) <= date < this.$strToDate(item.FROM_TIME, item.END_TIME, 1)
      )[0];
    },
  },
  watch: {
    darkMode(value) {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    '$i18n.locale'(val) {
      window.parent.postMessage(val, '*');
      this.changeLocale();
    },
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/intro.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/intro-dark.css" scoped></style>
<style src="@/../node_modules/swiper/swiper.css" scoped></style>
<style src="@/../node_modules/swiper/modules/autoplay/autoplay.min.css" scoped></style>
<style scoped>
.swiper-wrapper {
  -webkit-transition-timing-function: cubic-bezier(0.47, 0.09, 0.51, 1.26) !important;
  -o-transition-timing-function: cubic-bezier(0.47, 0.09, 0.51, 1.26) !important;
  transition-timing-function: cubic-bezier(0.47, 0.09, 0.51, 1.26) !important;
}
</style>
